<template>
  <div>
    <transition name="el-fade-in">
      <div class="transition-box" v-show="showPollutantLayer">
        <a-checkbox v-model="showPollutant">
          显示污染源
        </a-checkbox>
        <a-tooltip>
          <template slot="title">
            <span>注：在地图上右击新建污染源</span>
          </template>
          <a-icon type="exclamation-circle" theme="filled" />
        </a-tooltip>
        <a-table
          :columns="columns"
          :data-source="pollutantList"
          rowKey="id"
          size="middle"
          :pagination="{
            current: page,
            total: total,
            pageSize: size,
            onChange: onPageChange
          }"
        >
          <template slot="idx" slot-scope="text, record, index">
            {{ (page - 1) * size + index + 1 }}
          </template>
          <template slot="is_reform" slot-scope="text">
            {{ text ? "是" : "否" }}
          </template>
          <template slot="is_check" slot-scope="text">
            {{ text ? "是" : "否" }}
          </template>
        </a-table>
      </div>
    </transition>
    <add-or-edit-pollutant
      :visible.sync="visible"
      :action="action"
      :record="record"
      @onOk="onOk"
      @onClose="onClose"
    ></add-or-edit-pollutant>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import { pollutant_map_columns } from "@/options/columns";
import { getPollutantList } from "@/api/api";
import AddOrEditPollutant from "@/components/pollutant_layer/AddOrEditPollutant";
export default {
  name: "PollutantLayer",
  data() {
    return {
      showPollutant: false,
      columns: pollutant_map_columns,
      pollutantList: [],
      page: 1,
      size: 8,
      total: 0,
      contextMenu: null,
      contextMenuPositon: null,
      visible: false,
      marker: null,
      action: "",
      record: {
        lng: null,
        lat: null
      },
      pollutantLayer: null
    };
  },
  components: {
    AddOrEditPollutant
  },
  props: ["showPollutantLayer", "map"],
  watch: {
    showPollutant() {
      this.getAllPollutantList();
    }
  },
  computed: {
    ...mapState(["userMenuPower"]),
    ...mapGetters(["defaultInfo"])
  },
  mounted() {
    //创建右键菜单
    this.contextMenu = new AMap.ContextMenu();
    //地图绑定鼠标右击事件——弹出右键菜单
    this.map.on("rightclick", e => {
      this.contextMenu?.open(this.map, e.lnglat);
      this.contextMenuPositon = e.lnglat;
    });
    this.contextMenu.addItem(
      "复制经纬度(gcj02)",
      e => {
        this.copyLngLatClipboard("gcj02");
      },
      1
    );
    this.contextMenu.addItem(
      "复制经纬度(bd09)",
      e => {
        this.copyLngLatClipboard("bd09");
      },
      2
    );
    this.contextMenu.addItem(
      "复制经纬度(wgs84)",
      e => {
        this.copyLngLatClipboard("wgs84");
      },
      3
    );
    if (this.userMenuPower.controls?.pollutantOperation) {
      this.showContextMenu();
    }
    this.getPollutantList();
  },
  methods: {
    copyLngLatClipboard(type) {
      let lnglat = [];
      if (type == "bd09") {
        const bd09 = coordtransform.gcj02tobd09(
          this.contextMenuPositon.lng,
          this.contextMenuPositon.lat
        );
        lnglat = bd09;
      } else if (type == "wgs84") {
        const wgs84 = coordtransform.gcj02towgs84(
          this.contextMenuPositon.lng,
          this.contextMenuPositon.lat
        );
        lnglat = wgs84;
      } else if (type == "gcj02") {
        lnglat = [this.contextMenuPositon.lng, this.contextMenuPositon.lat];
      } else {
      }
      let text = `${lnglat[1]},${lnglat[0]}`;

      let textArea = document.createElement("textarea");
      textArea.style.position = "fixed";
      textArea.style.top = 0;
      textArea.style.left = 0;
      textArea.style.width = "2em";
      textArea.style.height = "2em";
      textArea.style.padding = 0;
      textArea.style.border = "none";
      textArea.style.outline = "none";
      textArea.style.boxShadow = "none";
      textArea.style.background = "transparent";
      textArea.value = text;
      document.body.appendChild(textArea);
      textArea.select();

      try {
        // let msg = document.execCommand("copy") ? "成功" : "失败";
        document.execCommand("copy");
        this.$notification.success({
          message: "成功",
          description: "已复制"
        });
        this.contextMenu?.close();
      } catch (err) {
        console.log(err);
        this.$notification.error({
          title: "失败",
          description: err
        });
        this.contextMenu?.close();
      }

      document.body.removeChild(textArea);
    },
    async getAllPollutantList() {
      if (this.showPollutant) {
        try {
          let res = await getPollutantList({
            group_id: this.defaultInfo.defaultGroupId
          });
          let list = res.data.items;
          let opts = {
            zIndex: 10,
            drawMode: "icon",
            icon: {
              img: "static/images/changsuoxuncha.png",
              width: 20,
              height: 26,
              deg: 0
            },
            point: {
              size: 5
            },
            events: {
              click: () => {}
            }
          };
          this.pollutantLayer = new nMapGD.CanvasCommonLayer(
            this.map,
            list,
            opts
          );
        } catch (error) {
          console.log(error);
        }
      } else {
        this.pollutantLayer && this.pollutantLayer.hide();
      }
    },
    async getPollutantList() {
      try {
        let res = await getPollutantList({
          group_id: this.defaultInfo.defaultGroupId,
          page: this.page,
          size: this.size
        });
        this.pollutantList = res.data.items;
        this.total = res.data.total;
      } catch (error) {
        console.log(error);
      }
    },
    onOk(v) {
      this.visible = v;
      this.marker && this.marker.hide();
      this.contextMenu && this.contextMenu.close();
      this.marker = null;
      this.getPollutantList();
      this.getAllPollutantList();
    },
    onClose(v) {
      this.visible = v;
      this.marker && this.marker.hide();
      this.contextMenu && this.contextMenu.close();
      this.marker = null;
    },
    onPageChange(v) {
      this.page = v;
      this.getPollutantList();
    },
    showContextMenu() {
      //右键添加Marker标记
      this.contextMenu.addItem(
        "添加污染源",
        e => {
          let icon = new AMap.Icon({
            // 图标尺寸
            size: new AMap.Size(20, 26),
            // 图标的取图地址
            image: "static/images/changsuoxuncha.png",
            // 图标所用图片大小
            imageSize: new AMap.Size(20, 26)
          });
          this.marker = new AMap.Marker({
            map: this.map,
            icon: icon,
            position: this.contextMenuPositon, //基点位置
            offset: new AMap.Pixel(-10, -26)
          });
          let position = this.marker.getPosition();
          this.record.lng = position.lng;
          this.record.lat = position.lat;
          this.action = "add";
          this.visible = true;
        },
        0
      );
    }
  }
};
</script>

<style lang="less" scoped>
.transition-box {
  position: absolute;
  z-index: 1;
  padding: 10px 20px;
  background: #fff;
  top: 10px;
  right: 60px;
  width: 650px;
  max-height: 500px;
}
</style>
